module.exports = __webpack_public_path__ + "static/media/youtube.65f294af.png";